import { FlowOutputStepInfo } from '~src/flow/models/FlowOutputStepInfo';

import { Recipient } from '../types/Recipient';

export const DEFAULT_SHOULD_INCLUDE_LINK_TO_DATASOURCE: boolean = true;
export const DEFAULT_SHOULD_SHOW_FIRST_N_ROWS: boolean = true;
export const DEFAULT_SHOULD_ATTACH_OUTPUT_DATA_TO_EMAIL: boolean = false;

export function isSelectedOutputAPublishedDatasource(selectedId: string, outputs: ReadonlyArray<FlowOutputStepInfo>): boolean {
  let isSelectedOutputPublishedDatasource: boolean = false;
  outputs.forEach((output) => {
    if (output.id === selectedId &&
        (output.dataConnection.connectionDetails.type === 'tableauserversite' || output.dataConnection.connectionDetails.type === 'tableauserver')) {
          isSelectedOutputPublishedDatasource = true;
        }
  });
  return isSelectedOutputPublishedDatasource;
}

export function getEmailRecipientUserIds(emailRecipients: Recipient[], currentUserId?: string) {
  const emailRecipientIds = emailRecipients.filter((recipient) => {
    return recipient.kind === 'USER';
  }).map((user) => {
    return user.id;
  });
  if (currentUserId && !emailRecipientIds.includes(currentUserId)) {
    emailRecipientIds.push(currentUserId);
  }
  return emailRecipientIds;
}

export function getEmailRecipientGroupIds(emailRecipients: Recipient[]) {
  const emailRecipientIds = emailRecipients.filter((recipient) => {
    return recipient.kind === 'GROUP';
  }).map((group) => {
    return group.id;
  });
  return emailRecipientIds;
}

/**
 * The email form is valid if atleast 1 recipient is selected and the subject is not null or the empty string
 */
export function isValidEmailTemplate(
  shouldSendToMe: boolean,
  emailRecipients: Recipient[],
  subjectValue: string,
  shouldIncludeOutputData: boolean,
  selectedOutputForSubcription: string | null) {
  const hasRecipient: boolean = shouldSendToMe || emailRecipients.length > 0;
  return hasRecipient && (subjectValue !== '' && subjectValue !== null) &&
    (!shouldIncludeOutputData || (shouldIncludeOutputData && selectedOutputForSubcription !== null));
}